import { Injectable } from '@angular/core';
import {ResourcesService} from '../resources.service';
import {Observable} from 'rxjs/Observable';
import {UserService} from '../user/user.service';

@Injectable()
export class CommunityService {

  constructor(
    private _resources: ResourcesService,
    private _user: UserService
  ) { }

  sendConnectRequestToSupplier(supplierId: string | number): Observable<any> {
    return this._resources.post(
      'community/SendConnectRequestToSupplier',
      {
        agentId: this._user.userAccountTypeDefault.agent.id,
        supplierId: supplierId ? supplierId : null,
      }
    );
  }

  removeSupplierProtocol(supplierId: string | number): Observable<any> {
    return this._resources.get(
      'community/AgentRemoveSupplierProtocol?agentId=' + this._user.userAccountTypeDefault.agent.id + '&supplierId=' + supplierId,
    );
  }

  getSuppliersToAgent(): Observable<any[]> {
    return this._resources.get('Community/GetSuppliersToAgent?agentId=' + this._user.userAccountTypeDefault.agent.id);
  }

  getSupplierByIdToAgent(supplierId: string | number): Observable<any> {
    return this._resources.get(
      'community/GetSupplierByIdToAgent?agentId=' + this._user.userAccountTypeDefault.agent.id + '&supplierId=' + supplierId
    );
  }

  sendReportAbuseAboutSupplier(aboutAgentId: number | string, aboutSupplierId: number | string, message: string) {
    return this._resources.post(
      'community/SendReportAbuseAboutSupplier',
      {
        fromAgentId: this._user.userAccountTypeDefault.agent.id,
        fromSupplierId: this._user.userAccountTypeDefault.supplierId,
        aboutAgentId: aboutAgentId,
        aboutSupplierId: aboutSupplierId,
        message: message
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/community/community.service.ts